<div *ngIf="showForm">
  <ngb-alert
    [type]="color"
    [dismissible]="false"
    class="text-center w-100 position-relative">

    {{ message }}

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="Cancel()">
      <span aria-hidden="true">&times;</span>
    </button>

  </ngb-alert>

  <div class="text-center my-4">
    <button class="btn btn-primary mx-2" (click)="Confirm()">
      {{ globalService.Get("YES") }}
    </button>

    <button class="btn btn-outline-secondary mx-2" (click)="Cancel()">
      {{ globalService.Get("NO") }}
    </button>
  </div>
</div>